import PropTypes from "prop-types"
import React from "react"

import BaseAvatar from "src/components/BaseAvatar"
import SelectionChip from "src/components/SelectionChip"

const feetLabel = (inches) => {
  if (!inches || inches <= 0) return null
  const feet = Math.floor(inches / 12)
  const remainder = inches % 12
  return remainder ? `${feet}'${remainder}"` : `${feet}'`
}

const boatIconFor = (type) => {
  if (type === "sail") return "icon-sailboat"
  if (type === "power") return "icon-power-boat"
  return "icon-md-directions-boat"
}

const BoatSummaryChip = ({ boat, onRemove }) => {
  if (!boat?.name) return null

  const yearMakeModel = [boat.year, boat.make, boat.model]
    .filter(Boolean)
    .join(" ")

  const loa = feetLabel(boat.length_overall || boat.lengthOverall)
  const beam = feetLabel(boat.beam)
  let dimensions = null
  if (loa && beam) dimensions = `${loa} × ${beam}`
  else if (loa) dimensions = loa
  else if (beam) dimensions = beam

  const photoUrl = boat.photoUrl || boat.photo_url
  const boatType = boat.boat_type || boat.boatType
  const metaSegments = [yearMakeModel, dimensions].filter(Boolean)

  const avatar = (
    <BaseAvatar
      size="xxs"
      src={photoUrl}
      name={boat.name}
      backgroundColor="bg-teal-100"
      fallback={
        <i
          className={`icon ${boatIconFor(
            boatType
          )} text-sm leading-none text-teal-700`}
          aria-hidden="true"
        />
      }
    />
  )

  return (
    <SelectionChip
      avatar={avatar}
      onRemove={onRemove}
      ariaLabel="Selected boat"
    >
      <span className="truncate font-medium text-gray-900">{boat.name}</span>
      {metaSegments.map((segment) => (
        <React.Fragment key={segment}>
          <span className="text-gray-300" aria-hidden="true">
            ·
          </span>
          <span className="truncate text-gray-500">{segment}</span>
        </React.Fragment>
      ))}
    </SelectionChip>
  )
}

BoatSummaryChip.propTypes = {
  boat: PropTypes.shape({
    name: PropTypes.string.isRequired,
    year: PropTypes.string,
    make: PropTypes.string,
    model: PropTypes.string,
    boat_type: PropTypes.string,
    boatType: PropTypes.string,
    length_overall: PropTypes.number,
    lengthOverall: PropTypes.number,
    beam: PropTypes.number,
    photoUrl: PropTypes.string,
    photo_url: PropTypes.string,
  }),
  onRemove: PropTypes.func,
}

export default BoatSummaryChip
